import { render, staticRenderFns } from "./ArenaCard.vue?vue&type=template&id=2dcfd2af&"
import script from "./ArenaCard.vue?vue&type=script&lang=js&"
export * from "./ArenaCard.vue?vue&type=script&lang=js&"
import style0 from "./ArenaCard.vue?vue&type=style&index=0&id=2dcfd2af&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports